// import React, { createContext, useContext, useEffect, useState } from "react";

// const AccessTokenContext = createContext({ accessToken: "", setAccessToken: (token: string) => {} });

// export const AccessTokenProvider = ({ children }) => {
//   const [accessToken, setAccessToken] = useState("");

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       setAccessToken(token);
//     }
//   }, []);

//   return (
//     <AccessTokenContext.Provider value={{ accessToken, setAccessToken }}>
//       {children}
//     </AccessTokenContext.Provider>
//   );
// };

// export const useAccessToken = () => useContext(AccessTokenContext);

import React, { createContext, useContext, useEffect, useState } from "react";

// สร้าง type เพื่อให้ Editor ช่วยเช็ก error ได้
interface AccessTokenContextType {
  accessToken: string;
  setAccessToken: (token: string) => void;
  clearAccessToken: () => void;
}

// ตัว context จริง
const AccessTokenContext = createContext<AccessTokenContextType>({
  accessToken: "",
  setAccessToken: () => {},
  clearAccessToken: () => {},
});

// ตัว provider ที่เอาไปครอบ App
export const AccessTokenProvider = ({ children }: { children: React.ReactNode }) => {
  const [accessToken, setAccessTokenState] = useState<string>("");

  // อ่าน token จาก localStorage ตอนเปิดแอพ
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setAccessTokenState(token);
    }
  }, []);

  // ฟังก์ชัน set token (เช่นตอน login)
  const setAccessToken = (token: string) => {
    localStorage.setItem("token", token);
    setAccessTokenState(token);
  };

  // ฟังก์ชัน clear token (เช่นตอน logout)
  const clearAccessToken = () => {
    localStorage.removeItem("token");
    setAccessTokenState("");
  };

  return (
    <AccessTokenContext.Provider value={{ accessToken, setAccessToken, clearAccessToken }}>
      {children}
    </AccessTokenContext.Provider>
  );
};

// ตัว hook ที่ไว้ใช้งานในทุกหน้า
export const useAccessToken = () => useContext(AccessTokenContext);
